import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CardGifPanel from '../components/CardGifPanel';
import { PageHeader, SectionCap } from '../components/Editorial';

/* /cards — where the "Your card is ready" push and message land in a browser
   (old app builds, desktop). New app builds open the card in-app instead.
   `?for=<athlete user id>` is handled by ActingAthleteFromLink in App.js, so a
   guardian sees the athlete the link is about. */

export const NOT_READY_TEXT = "Your player card isn't ready yet. We build it overnight from your profile photo.";

export default function CardsPage() {
  const [state, setState] = useState('loading');

  return (
    <div className="ed-page">
      <PageHeader eyebrow="PROFILE · PLAYER CARD" title="Player card" />
      <CardGifPanel onState={setState} />
      {state === 'none' && (
        <>
          <SectionCap label="Your player card" />
          <div className="ed-card">
            <p style={{ marginTop: 0 }}>{NOT_READY_TEXT}</p>
            <Link to="/profile">Go to your profile</Link>
          </div>
        </>
      )}
    </div>
  );
}
